import React from 'react'
import {Lang} from 'yougile-lang'
import {DataField, Hub} from 'yougile-model'
import {ButtonNew} from '@components/common/base/buttons'
import {SuggestItem} from '@components/common/input-with-suggest/input-with-suggest'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {getLegacyCrmFieldValueById} from '@components/crm/default-data-fields'
import {CustomFieldInput} from '@components/right-panel/crm/about-client/custom-field-input'
import {
  ConfirmedSuggestItem,
  CustomFieldInputWithSuggest
} from '../about-client/custom-field-input-with-suggest'

type LinkedHubWithFields = {
  hub?: Hub
  label: string
  suggestions: SuggestItem[]
  fields?: DataField[]
  getAddAsNewLabel?: (value: string) => string
  onLink: (link: ConfirmedSuggestItem) => void
  onClickUnlink: () => void
}

export const LinkedHubWithFields = (props: LinkedHubWithFields) => {
  const {
    hub,
    label,
    suggestions,
    fields,
    getAddAsNewLabel,
    onLink,
    onClickUnlink
  } = props

  if (!hub) {
    return (
      <CustomFieldInputWithSuggest
        label={label}
        suggestions={suggestions}
        getAddAsNewLabel={getAddAsNewLabel}
        onConfirm={onLink}
      />
    )
  }

  return (
    <div className="mb-12">
      <CustomFieldInput
        label={label}
        value={hub.title}
        allowEmpty={false}
        actions={
          <Tooltip content={Lang.msg.crm.unlinkFromDeal}>
            <ButtonNew
              icon="IconLinkOff"
              className="self-center ml-4 shadow-none"
              color="secondary"
              onClick={onClickUnlink}
            />
          </Tooltip>
        }
        onConfirm={newTitle => {
          const normalizedTitle = newTitle.trim()
          if (normalizedTitle.length > 0) {
            hub.title = normalizedTitle
            hub.commit()
          }
        }}
      />
      {fields?.map(field => {
        const value =
          hub.data.fieldValues?.[field.id] ??
          getLegacyCrmFieldValueById(hub.data, field.id) ??
          ''

        return (
          <CustomFieldInput
            key={field.id}
            label={field.label}
            value={value}
            onConfirm={nextValue => {
              hub.data.fieldValues ??= {}
              hub.data.fieldValues[field.id] = nextValue
              hub.commit()
            }}
            type={field.type}
          />
        )
      })}
    </div>
  )
}
